<template>

  <v-dialog v-model="dialog" scrollable width="800px">
    <v-card>

      <v-card color="transparent" flat>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline bluetext">
          {{title}}
        </v-card-text>
      </v-card>
      <v-card-text>
        <v-layout row wrap justify-start>
          <v-flex>
            <v-card flat>
              <v-card-title class="subtitle-1">
                {{description}}
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="doCancel()" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Abbrechen
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="doSave()" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DialogDefault',
    components: {},
    methods: {
      /**
       * newName, title, type
       * @param cardConfig
       */
      doCancel: function () {
        this.dialog = false
        this.$emit('cancel', null)
      },
      doSave: function () {
        this.dialog = false
        this.$emit('save', {})
      },
      open: function (cardConfig) {
        if ((cardConfig != null) && (cardConfig)) {
          this.title = cardConfig.title
          this.description = cardConfig.description
        }
        this.dialog = true
      }
    },
    data () {
      return {
        title: 'Login nicht erfolgreich',
        description: 'Wir konnten die Kombination aus Username und Passwort nicht validieren',
        dialog: false
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>
